import React from 'react';
import { X } from 'lucide-react';
import './ModalCloseButton.css';

const ModalCloseButton = ({ onClick, className = '', size = 'medium' }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <button 
      className={`modal-close-button modal-close-button--${size} ${className}`}
      onClick={handleClick}
      aria-label="Close modal"
    >
      <X size={size === 'small' ? 16 : size === 'large' ? 32 : 24} />
    </button>
  );
};

export default ModalCloseButton;
